import { TimelineStop } from './GanttRow'

/**
 * Used by `react-dnd` to identify the type of drag event
 */
export const GanttChartDragType = {
  STOP: 'GANTT_STOP', // Default drag type if dragType is not provided
} as const

type GridTableDragType = keyof typeof GanttChartDragType


/**
 * Used to communicate information from the different drag sources
 */
export type GanttChartDragItem = {
  id: string | number
  type: GridTableDragType
  stop: TimelineStop // The row being dragged
}